import { useEffect, ReactNode } from 'react';

import { useAppDispatch } from 'hooks/useAppDispatch';
import { getAppConfigThunk } from 'state/settings/settings-thunks';
import { APP_CONFIG_PROFILES } from 'config/app-config';

type Props = {
  children: ReactNode;
};
export const AppConfigProvider = ({ children }: Props) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    Promise.allSettled(
      Object.values(APP_CONFIG_PROFILES).map((profile) =>
        dispatch(getAppConfigThunk(profile))
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return children;
};
